export default __webpack_public_path__ + "static/media/sidebar1.dcdccdf3.jpg";